import React from 'react';
import './Reviews.css';

function Reviews({ language }) {
  return (
    <section id="reviews" className="section-light">
      <div className="container">
        <div className="section-title-center">
          <h2>Client Testimonials</h2>
          <p>See what my clients have to say about their experience</p>
        </div>

        <div className="google-reviews-badge">
          <i className="fab fa-google google-logo"></i>
          <h3>Google Reviews • 4.9/5 Stars</h3>
        </div>

        <p style={{textAlign: 'center', marginTop: '20px', color: '#6C757D'}}>
          Real feedback from verified clients. Click to see all reviews on Google.
        </p>
      </div>
    </section>
  );
}

export default Reviews;
